module.exports = __webpack_public_path__ + "static/media/8.fa623f13.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/九宫格未选中态/8.png
// module id = 1626
// module chunks = 0